import { AccountOwnership } from 'app/types/User';

export function accountOwnershipToDisplayName(enumValue: AccountOwnership) {
  switch (enumValue) {
    case AccountOwnership.SelfRegistered:
      return 'Self-registered';
    case AccountOwnership.DistributorsCustomer:
      return "Distributor's customer";
    case AccountOwnership.AzureMarketplace:
      return 'Azure marketplace';
    case AccountOwnership.TomTomCustomer:
      return 'TomTom customer';
    case AccountOwnership.Internal:
      return 'Internal';
    default:
      return 'Unknown';
  }
}
